<script setup lang="ts">
import { useFormatNumber } from '@/shared/composables/useFormatNumber'
import { computed } from 'vue'

const { formatNumber, withUnitSeparate } = useFormatNumber()

export type ValueBoxProps = {
  value: number | string | undefined
  unit?: string
  inputUnit?: string
  numDecimals?: number
  numDigits?: number
}

const props = withDefaults(defineProps<ValueBoxProps>(), {})

const display = computed(() => {
  if (typeof props.value !== 'number') {
    return { value: props.value, unit: props.unit }
  }
  if (props.inputUnit) {
    return withUnitSeparate(props.value, props.numDecimals, props.inputUnit, props.unit)
  }
  return {
    value: formatNumber(props.value, { maximumFractionDigits: props.numDecimals }).value,
    unit: props.unit
  }
})
</script>

<template>
  <div class="flex gap-1 rounded px-1 py-0.5 text-center whitespace-nowrap">
    <span :style="{ minWidth: props.numDigits ? numDigits + 'ch' : undefined }">{{ display.value }}</span>
    <span
      v-if="display.unit"
      class="text-muted-foreground"
    >
      {{ display.unit }}
    </span>
  </div>
</template>
